import React from 'react';

interface RefreshErrorBannerProps {
    message: string;
    rateLimited: boolean;
    onRetry?: () => void;
    rounded?: 'lg' | 'xl';
    compact?: boolean;
    className?: string;
}

const RefreshErrorBanner: React.FC<RefreshErrorBannerProps> = ({
    message,
    rateLimited,
    onRetry,
    rounded = 'xl',
    compact = false,
    className,
}) => (
    <div className={[
        'border text-sm',
        rounded === 'xl' ? 'rounded-xl' : 'rounded-lg',
        compact ? 'px-3 py-2' : 'px-4 py-3',
        rateLimited
            ? 'border-amber-200 bg-amber-50 text-amber-800'
            : 'border-red-200 bg-red-50 text-red-700',
        className,
    ].filter(Boolean).join(' ')}>
        <div className={`flex items-center justify-between ${compact ? 'gap-3' : 'gap-4'}`}>
            <span>{message}</span>
            {onRetry && (
                <button onClick={onRetry} className="font-medium text-blue-600 hover:text-blue-800">
                    Try again
                </button>
            )}
        </div>
    </div>
);

export default RefreshErrorBanner;
